import DialogManager from '../../utils/dialog-manager.mjs';
import configuration from '../../configuration.mjs';
/**
 * @param {Element} rootElement
 */
export default (rootElement = document.body) => {
  const estatePdfLink = rootElement.querySelector('#estate-pdf-link');
  const estatePdfDialog = rootElement.querySelector('#estate-pdf-dialog');
  const estatePdfDialogInnerContainer = estatePdfDialog?.querySelector('.inner-container');
  const closeButton = estatePdfDialog?.querySelector('#estate-pdf-close-button');

  if(!estatePdfLink || !estatePdfDialog || !closeButton || !estatePdfDialogInnerContainer) {
    return;
  }

  DialogManager.addDialog(estatePdfDialog);

  let abortController = null;

  estatePdfLink.addEventListener('click', event => {
    event.preventDefault();

    estatePdfDialogInnerContainer.classList.remove('has-failed');
    DialogManager.openDialog(estatePdfDialog);

    abortController = new AbortController();

    fetch(estatePdfLink.dataset.url, { signal: abortController.signal })
      .then(response => {
        if(!response.ok) {
          throw new Error('Failed to fetch PDF document.');
        }
        return response.blob();
      })
      .then(blob => {
        DialogManager.closeDialog(estatePdfDialog);

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `estate-${configuration.estate.shortId}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        if(error.name === 'AbortError') {
          return;
        }

        console.error('Failed to generate PDF.', error);
        estatePdfDialogInnerContainer.classList.add('has-failed');
      });
  });

  closeButton.addEventListener('click', () => {
    if(!!abortController) {
      abortController.abort();
    }

    DialogManager.closeDialog(estatePdfDialog);
  });
};
